import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f8bc034&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8bc034",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8bc034')) {
      api.createRecord('7f8bc034', component.options)
    } else {
      api.reload('7f8bc034', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f8bc034&scoped=true&", function () {
      api.rerender('7f8bc034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/ClientLayout/index.vue"
export default component.exports